module.exports = __webpack_public_path__ + "static/media/truck-img1.322014b2.png";